var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIconInactiveWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,21.1l4,5.5c0.5,0.6,1.2,1,2,1h5.8c0.8,0,1.5-0.4,2-1l4-5.5c3.3-4.5,2.6-10.7-1.6-14.3s-10.5-3.7-14.7,0 C4.5,10.4,3.8,16.6,7.1,21.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,20l3.1,4.3c0.4,0.5,0.9,0.8,1.5,0.8h4.5c0.6,0,1.2-0.3,1.5-0.8l3.1-4.3c2.5-3.5,2-8.4-1.2-11.3 c-3.5-3.2-8.9-2.9-12.1,0.7C7,12.3,6.7,16.8,9.1,20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,12h-1.8c0,0-0.1,0-0.1,0.1v0.1v7.6v0.1c0,0,0,0.1,0.1,0.1h1.8c0.1,0,0.1-0.1,0.1-0.2v-7.6 C17,12.1,17,12.1,16.9,12C17,12,16.9,12,16.9,12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconInactiveWhite);
export default __webpack_public_path__ + "static/media/lock_icon_inactive_white.3787ae5441f67b76eaa4ee1567e683c6.svg";
export { ForwardRef as ReactComponent };